import script from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SymbolPanel.vue?vue&type=style&index=0&id=ba0c96fc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0c96fc"]])

export default __exports__